import Template from '@/banner_template/Template';
import { addPointByOrigin, updateObject } from '../../helpers';
import { setDataForExistFields } from './set-data-for-exist-fields';

export const resizeProportionalTemplateHandler = ({
  preview,
  isCopyObject,
  alignContent,
  dimension,
  mainTemplate,
  canvas,
  isUseDestinationTemplateFields,
  templateSettings,
}) => {
  const canvasDimensions = {
    width: preview.dimension?.[0] ?? (canvas.width / canvas.getZoom()),
    height: preview.dimension?.[1] ?? (canvas.height / canvas.getZoom()),
  };
  let allObjects = canvas.getObjects(),
      template = new Template(dimension?.template || {}),
      rsW = dimension.width / canvasDimensions.width,
      rsH = dimension.height / canvasDimensions.height,
      scale = Math.min(rsW, rsH);

  if (isUseDestinationTemplateFields) {
    allObjects = setDataForExistFields({
      allObjects,
      template,
      mainTemplate,
      isCopyObject,
      templateSettings
    });
  }

  for (const _object of allObjects) {
    const object = isCopyObject ? _.cloneDeep(_object) : _object;
    const origins = ['right', 'bottom'];
    const points = object.getPointByOrigin(...origins);

    object.set({
      scaleX: object.scaleX * scale,
      scaleY: object.scaleY * scale,
    })

    if (object.rx && object.ry) {
      object.rx *= scale;
      object.ry *= scale;
    }

    const additionPoint = addPointByOrigin({
      toDimension: dimension,
      fromDimension: {
        width: canvasDimensions.width,
        height: canvasDimensions.height,
      },
      scale,
      alignContent
    });

    object.setPositionByOrigin({
      x: points.x * scale + additionPoint.x,
      y: points.y * scale + additionPoint.y
    }, ...origins);

    object.setCoords();

    updateObject(object, { x: rsW, y: rsH, alignContent });
  }
}
